export const META_TAGS = {
  title: 'Where the best in the world, become the best in the world.',
  description: 'Join the Gaming Community and learn from the Best Creators and Coaches in the World.'
};

export const CANCELED_REASONS_LABELS = {
  badTime: 'My schedule is too busy',
  badPerson: "I don't want to talk to this person",
  badFit: 'I’m not a suitable fit for this persons needs',
  badMarks: 'The match start times are not marked',
  badMatchCount: 'Incorrect number of matches',
  other: 'Other'
};

/** legacy / to be deprecated */
export const CANCELATION_POLICIES = {
  none: { label: '', value: 0 },
  flexible: { label: '24 hours', value: 1 },
  moderate: { label: '3 days', value: 3 },
  firm: { label: '7 days', value: 7 }
};

export const DEFAULT_RESCHEDULE_PERCENTAGE = 50;
export type SelectableReschedulePolicy = { label: string; value: number };
export const RESCHEDULE_POLICIES: SelectableReschedulePolicy[] = [
  { label: '24 hours', value: 24 },
  { label: '48 hours', value: 24 * 2 },
  { label: '72 hours', value: 24 * 3 },
  { label: '1 week', value: 24 * 7 }
];

export const OFFSITE_LINKS = {
  terms: 'https://metafy.gg/legal/terms',
  privacy: 'https://metafy.gg/legal/privacy',
  conduct: 'https://metafy.gg/legal/conduct'
};
